/**
 * The APIs answer in short Portuguese without accents (they also go to logs).
 * The ones a person can meet on the site are rewritten here; anything else is
 * shown as it came, with a capital letter.
 */
const MESSAGES: Record<string, string> = {
  // identity-api
  'login ja em uso': 'Esse login já está em uso. Escolhe outro.',
  'email ja registado': 'Esse email já tem conta. Entra com ele, ou usa “Esqueci-me da password”.',
  'login ou password errados': 'Login ou password errados.',
  'conta desativada': 'Esta conta está desativada. Fala com a Grow uP.',
  'esta conta nao entra no site': 'Esta conta é de um jovem da Arena e só entra nos PCs da Arena.',
  'link invalido ou expirado':
    'Este link já foi usado ou expirou. Pede um novo e usa o mais recente.',
  'password atual errada': 'A password atual não está certa.',
  'codigo errado': 'Código errado. Confirma a hora do telemóvel e tenta de novo.',
  'codigo de recuperacao errado ou ja usado': 'Código de recuperação errado ou já usado.',
  'desafio invalido ou expirado; volta a entrar': 'Passou demasiado tempo. Volta a entrar.',
  'cerimonia expirada; tenta outra vez': 'Passou demasiado tempo. Tenta outra vez.',
  'passkey recusada': 'A passkey não foi aceite.',
  'passkey desconhecida': 'Esta passkey não pertence a nenhuma conta Grow uP.',
  'entra com o segundo fator primeiro':
    'Para mudar o segundo passo, sai e volta a entrar usando-o.',
  'staff precisa de pelo menos um segundo fator; junta outro antes':
    'Quem é staff precisa sempre de um segundo passo. Junta outro antes de remover este.',
  'autenticador ja configurado': 'A app autenticadora já está ativa.',
  'a conta ja tem password': 'Esta conta já está ativa. Entra com a tua password.',
  'sessao expirada': 'A sessão expirou. Entra de novo.',
  'sem sessao': 'Entra primeiro.',
  // members-api
  'confirma primeiro o email da conta':
    'Confirma primeiro o teu email: abre o link que te enviámos.',
  'ja es membro': 'Já és membro.',
  'ja tens um pedido pendente': 'Já tens um pedido à espera de aprovação.',
  'menores tornam-se membros com o encarregado de educacao':
    'Menores de 18 anos tornam-se membros na Arena, com o encarregado de educação.',
  'a data de nascimento so e corrigida pela Grow uP':
    'A data de nascimento só pode ser corrigida pela Grow uP. Fala connosco.',
  'sem perfil; faz primeiro o pedido de membro': 'Faz primeiro o pedido de membro.',
  'convite invalido ou expirado':
    'Este convite já foi usado ou expirou. Pede à Grow uP para o reenviar.',
  'convite invalido': 'Este convite não é válido.',
  'nao es encarregado deste jovem': 'Não és encarregado de educação deste jovem.',
  'esta conta da rede ja esta ligada a outra conta Grow uP':
    'Essa conta já está ligada a outra conta Grow uP.',
  'o pedido de ligacao expirou; tenta de novo': 'Passou demasiado tempo. Tenta ligar de novo.',
  'pedido de ligacao invalido': 'A ligação não foi aceite. Tenta de novo a partir desta página.',
  'autorizacao recusada ou expirada': 'A autorização não foi dada ou expirou. Tenta de novo.',
  'numero do Cartao de Cidadao invalido':
    'Número do Cartão de Cidadão inválido. Confirma os 12 caracteres.',
  'telemovel invalido': 'Telemóvel inválido.',
  'codigo postal no formato 0000-000': 'Código postal no formato 0000-000.',
  'data de nascimento fora do intervalo': 'Data de nascimento inválida.',
  'data invalida': 'Data inválida.',
  'login invalido':
    'O login tem 3 a 32 caracteres: letras, números, ponto, hífen ou _, a começar por letra ou número.',
  'minimo 12 caracteres': 'A password precisa de pelo menos 12 caracteres.',
  'nome de utilizador invalido': 'Nome de utilizador inválido.',
  'codigo de 6 digitos': 'O código tem 6 dígitos.',
  'pedido invalido': 'Há campos por corrigir.',
  // streaming-api
  'liga primeiro a tua conta da Twitch':
    'Liga primeiro a tua conta da Twitch à conta Grow uP (no site, em Redes).',
  'escreve o nome do teu canal': 'Escreve o nome do teu canal da Twitch.',
  'nome de canal da Twitch invalido':
    'Nome de canal inválido: 4 a 25 letras, números ou _, como aparece em twitch.tv/<canal>.',
  'esse canal ja e de um streamer da Grow uP': 'Esse canal já é de um streamer da Grow uP.',
  'ja es streamer da Grow uP': 'Já és streamer da Grow uP.',
  'ja tens uma candidatura pendente': 'Já tens uma candidatura à espera de resposta.',
  'contas de jovem nao se candidatam a streamer':
    'Contas de jovem da Arena não se candidatam a streamer.',
  'aceita as regras para continuar': 'Aceita as regras para continuar.',
  'escreve o que transmites': 'Diz-nos o que transmites.',
  'diz quando costumas transmitir': 'Diz-nos quando costumas transmitir.',
  'conta-nos um pouco mais (minimo 20 caracteres)':
    'Conta-nos um pouco mais (mínimo 20 caracteres).',
  'ainda nao es streamer da Grow uP': 'Ainda não és streamer da Grow uP.',
};

export function friendlyMessage(raw: string): string {
  const known = MESSAGES[raw];
  if (known !== undefined) return known;
  return raw.length > 0 ? raw.charAt(0).toUpperCase() + raw.slice(1) : raw;
}
